import LazyLoad from 'vanilla-lazyload';
import { createStore } from 'vuex';

export default createStore({
  state: {
    lazy: new LazyLoad(),
    general: {
      de: null,
      it: null,
      fr: null
    },
    currentPageData: {},
    menuOpen: false,
    alternateLinks: null,
    pages: {},
    cookieConsentStrings: {
      de: null,
      it: null,
      fr: null
    }
  },
});
